import { Box } from '@mui/material';
import React from 'react';

import { useSwitchMenuContext } from '../../Components/SwitchMenu/SwitchMenuContext';
import { SwitchMenuItem } from '../../Components/SwitchMenu/SwitchMenuItem';
import { DATA_TEST } from '../../enums';
import { BackNavigation } from '../Components/BackNavigation';

interface ISwitchMenuProps {
  parentContainerRef: React.RefObject<HTMLUListElement> | null;
  handleClose(): void;
}

export const MobileSwitchMenu: React.FC<ISwitchMenuProps> = ({ parentContainerRef, handleClose }) => {
  const { menuItems: switchMenuItems, menuButtonLabel: switchMenuButtonLabel } = useSwitchMenuContext();
  const firstSwitchInputRef = React.useRef<HTMLInputElement>(null);
  const handleArrowDownFromBackNavigation = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowDown' && firstSwitchInputRef?.current) {
      e.preventDefault();
      e.stopPropagation();
      firstSwitchInputRef.current?.focus();
    }
  };

  return (
    <>
      <BackNavigation
        onClick={handleClose}
        handleArrowDownKey={handleArrowDownFromBackNavigation}
        title={switchMenuButtonLabel}
      />
      <Box sx={{ px: 4 }} data-test={DATA_TEST.mobile_switch_menu_container}>
        {switchMenuItems.map((item, index: number) => (
          <SwitchMenuItem
            switchLabel={item.switchLabel}
            key={item.title}
            title={item.title}
            description={item.description}
            value={item.value}
            onValueChange={item.onValueChange}
            dataOG={item.dataOG}
            autoFocus={false}
            firstSwitchInputRef={index === 0 ? firstSwitchInputRef : null}
            parentContainerRef={parentContainerRef}
            requiresOgAssistPermission={item.requiresOgAssistPermission}
          />
        ))}
      </Box>
    </>
  );
};
